import { Typography } from '@components/common/Typography';
import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 4rem 0 190px;
`;

export const PageTitle = styled(Typography)`
  padding: 2rem 0;
`;

export const NavWrapper = styled.nav`
  display: flex;
  justify-content: space-between;
  padding: 2rem 0;
  & > section {
    h4 {
      display: flex;
      align-items: center;
      color: ${({ theme }) => theme.colors.functional.darkestGray};
    }
    & > span {
      display: flex;
      align-items: center;
      padding-left: 3.2rem;
    }
    svg {
      display: flex;
      align-items: center;
      width: 2.4rem;
      margin-left: 1rem;
      cursor: pointer;
    }
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.functional.darkGray};
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    font-size: 1.3rem;
    & > section {
      & > span {
        padding-left: 2rem;
      }
  }
`;
